function functionUrl(functionName) {
  const configured = process.env.REACT_APP_CONFIRMATION_API_URL;
  if (configured) {
    return `${configured.replace(/\/$/, '')}/${functionName}`;
  }
  if (process.env.NODE_ENV === 'development') {
    const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
    return `https://us-central1-${projectId}.cloudfunctions.net/${functionName}`;
  }
  return `${window.location.origin}/api/${functionName}`;
}

export async function postJson(functionName, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(functionUrl(functionName), {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || 'Não foi possível concluir o envio');
  }
  return payload;
}

export function sendContactMessage({ name, whatsapp }) {
  return postJson('sendContactMessage', { name, whatsapp });
}
